import { useAdminStatsStore } from '@/infrastructure/store/adminStatsStore';

export const useAdminStats = () => {
  const store = useAdminStatsStore();
  return {
    stats: store.stats,
    isLoading: store.isLoading,
    error: store.error,
    fetchStats: store.fetchStats,
    clearError: store.clearError,
  };
};
